window.$ = window.jQuery = require("jquery");
import push from "push.js";
import "leaflet/dist/leaflet.css";

import Vue from "vue";
import App from "./Core.vue";
import router from "./router";

import fun from "./plugins/fun";
import AuthService from "./services/AuthService";
import base from "./plugins/base";
import constapp from "./plugins/const";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "./services/Service";
import _ from "lodash";
import moment from "moment";
import VueMoment from "vue-moment";
import IdleVue from "idle-vue";
import VueMask from "vue-the-mask";
import panZoom from "vue-panzoom";
import VueHtmlToPaper from 'vue-html-to-paper';
import HighchartsVue from "highcharts-vue";

import Datetime from 'vue-datetime' //jmr
import 'vue-datetime/dist/vue-datetime.css' //jmr

import VTooltip from 'v-tooltip'
// install plugin
Vue.use(panZoom);
Vue.use(HighchartsVue);
Vue.use(Datetime)//jmr
Vue.use(VTooltip, {
    defaultHtml: false,
  });
/** Activate vue.js plugins **/
Vue.use(VueMask);
const eventsHub = new Vue();
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: store.state.TimeInactive,
    startAtIdle: false,
});

Vue.use(VueHtmlToPaper);

Vue.use(_);
//Vue.use (VueAxios, axios)
Vue.prototype.moment = moment;
Vue.prototype.$const = constapp;
Vue.prototype.$fun = fun;
Vue.prototype.$push = push;
Vue.prototype.$http = axios;
//axios.defaults.timeout = 10000;
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token != null) {
            config.headers.common["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    (response) => {
        if (response.status === 200 || response.status === 201) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    (error) => {
        // ── Error de red / CORS / Timeout / sin respuesta del servidor ────────
        if (error.response == null) {
            const isTimeout = error.code === "ECONNABORTED" || (error.message && error.message.toLowerCase().includes("timeout"));
            if (isTimeout) {
                console.warn("[SunExpert] Timeout de solicitud:", error);
                fun.alert("La solicitud tardó demasiado tiempo en responder. Intente acotar los filtros o reintente en unos momentos.", "warning");
                return Promise.reject(error);
            }

            const hasToken = localStorage.getItem("token") != null;
            if (hasToken) {
                // Si el token JWT ya caducó (o fue rechazado en preflight CORS por expiración)
                if (AuthService.isTokenExpired()) {
                    console.warn("[SunExpert] Token expirado detectado en fallo de red:", error);
                    AuthService.clearSession();
                    fun.alert("La sesión ha caducado. Por favor vuelva a iniciar sesión.", "warning");
                    router.push("/login").catch(() => {});
                    return Promise.reject(error);
                }

                console.warn("[SunExpert] Error de red o sin respuesta del servidor con sesión activa:", error);
                fun.alert("Sin respuesta del servidor o conexión interrumpida. Verifique su red o intente nuevamente.", "warning");
            } else {
                console.warn("[SunExpert] Error de red sin sesión activa:", error);
                fun.alert("Sin conexión con el servidor. Verifique la red.", "warning");
            }
            return Promise.reject(error);
        }

        // ── Respuestas HTTP con código de estado ───────────────────────────────
        const getErrorMessage = (data, defaultMsg) => {
            if (!data) return defaultMsg;
            if (typeof data === "string") return data;
            if (data.Message) return data.Message;
            if (data.ExceptionMessage) return data.ExceptionMessage;
            if (data.message) return data.message;
            if (data.error) return data.error;
            if (Array.isArray(data) && data.length > 0) {
                return typeof data[0] === "string" ? data[0] : (data[0].Message || data[0].message || defaultMsg);
            }
            return defaultMsg;
        };

        switch (error.response.status) {
            case 400: {
                const rawMsg = getErrorMessage(error.response.data, "");
                if (rawMsg && rawMsg.includes("Personal no asignado al bus")) {
                    break;
                }
                fun.alert(getErrorMessage(error.response.data, "Error en la solicitud."), "warning");
                console.log(error.response.data);
                break;
            }
            case 401: {
                // Sesión expirada: token rechazado por el backend
                localStorage.setItem("isIdle", false);
                document.onload = null;
                document.onmousemove = null;
                document.onmousedown = null;
                document.ontouchstart = null;
                document.onclick = null;
                document.onscroll = null;
                AuthService.clearSession();
                fun.alert("La sesión ha caducado. Por favor vuelva a iniciar sesión.", "warning");
                router.push("/login").catch(() => {});
                break;
            }
            case 403:
                fun.alert("No tiene permisos para realizar esta acción.", "warning");
                break;
            case 404:
                if (localStorage.getItem("token") != null) {
                    fun.alert("El servicio solicitado no existe.", "warning");
                } else {
                    router.push("/login");
                }
                break;
            case 500:
                if (localStorage.getItem("token") != null) {
                    fun.alert(getErrorMessage(error.response.data, "Error interno del servidor."), "error");
                }
                break;
            case 502:
                if (localStorage.getItem("token") != null) {
                    fun.alert(getErrorMessage(error.response.data, "Error de puerta de enlace (502)."), "error");
                }
                break;
            default:
                console.warn("[SunExpert] Error HTTP no manejado:", error.response.status, error.response.data);
                break;
        }

        return Promise.reject(error);
    }
);

//vue filter
Vue.filter('numberDefaultKg', (value) => {
    // console.log("valor tuberia", value)
    if( value == -Infinity ) return 0; 
    if( value == Infinity ) return 0; 

    if( isNaN(value) ) return 0; 
    if( value == undefined ) return 0; 
    // if( value < 0 ) return 0; 
         
    
    // return value;
    return new Intl.NumberFormat("es-PE", { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2,
        // style: "unit",
        // unit: "KGM",
    }).format(value) + " Kg"
})

Vue.filter('numberDefault', (value) => {
    // console.log("valor tuberia", value)
    if( value == -Infinity ) return 0; 
    if( value == Infinity ) return 0; 

    if( isNaN(value) ) return 0; 
    if( value == undefined ) return 0; 
    // if( value < 0 ) return 0; 
         
    
    // return value;
    return new Intl.NumberFormat("es-PE", { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 ,
        // style: "unit",
        // unit: "KGM",
    }).format(value)
})

Vue.filter('numberDefault6', (value) => {
    // console.log("valor tuberia", value)
    if( value == -Infinity ) return 0; 
    if( value == Infinity ) return 0; 

    if( isNaN(value) ) return 0; 
    if( value == undefined ) return 0; 
    // if( value < 0 ) return 0; 
         
    
    // return value;
    return new Intl.NumberFormat("es-PE", { 
        minimumFractionDigits: 6, 
        maximumFractionDigits: 6,
        // style: "unit",
        // unit: "KGM",
    }).format(value)
})

Vue.filter('currencyPEN', (value) => {
    // Manejo de casos especiales
    if (value === -Infinity || value === Infinity || isNaN(value)) return 'S/ 0.00';
    if (value === undefined || value === null) return 'S/ 0.00';
    
    // Formateo como moneda peruana
    return new Intl.NumberFormat('es-PE', {
        style: 'currency',
        currency: 'PEN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        currencyDisplay: 'symbol' // Esto mostrará "S/" en lugar de "PEN"
    }).format(value);
})

// Load Locales ('en' comes loaded by default)
require("moment/locale/es");

// Choose Locale
moment.locale("es");

Vue.use(VueMoment, { moment });
Vue.directive("focus", {
    inserted: function(el) {
        el.firstChild.firstChild.childNodes[1].childNodes[1].focus();
    },
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    Datetime,//jmr
    VTooltip,
    render: (h) => h(App),
}).$mount("#app");